module.exports = __webpack_public_path__ + "img/ai-design.71bb3aa1.png";